import { useCallback, useMemo, useState } from "react";

const LocalStorageKey = "calauto-license-key";

export function useLicenseKey() {
  const [licenseKey, setLicenseKey] = useState<string | null>(() => {
    const licenseKey = localStorage.getItem(LocalStorageKey);
    return licenseKey ?? null;
  });

  const handleSetLicenseKey = useCallback(
    (newLicenseKey: string | null) => {
      if (newLicenseKey) {
        setLicenseKey(newLicenseKey);
        localStorage.setItem(LocalStorageKey, newLicenseKey);
      } else {
        setLicenseKey(null);
        localStorage.removeItem(LocalStorageKey);
      }
    },
    [setLicenseKey]
  );

  return useMemo(() => {
    return { licenseKey, setLicenseKey: handleSetLicenseKey };
  }, [licenseKey, handleSetLicenseKey]);
}
